import React from "react";
import PropTypes from "prop-types";

const TabsFilter = React.memo(({ data, activeTab, variant }) => {
  if (variant === "wa") {
    return (
      <div
        className="inline-flex max-w-full flex-wrap items-center gap-1 rounded-xl border border-wa-border bg-wa-panel p-1"
        role="tablist"
        aria-label="Filter"
      >
        {data.length > 0 &&
          data.map((item, index) => {
            const active = activeTab === item.name;
            return (
              <button
                key={item.id ?? index}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={item.onClick}
                className={`whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-wa-accent text-white shadow-sm"
                    : "text-wa-muted hover:bg-wa-hover hover:text-wa-text"
                }`}
              >
                {item.name}
              </button>
            );
          })}
      </div>
    );
  }

  return (
    <div className="flex h-12 rounded-md border border-wa-border bg-wa-panel sm:flex-none">
      {data.length > 0 &&
        data.map((item, index) => (
          <button
            key={index}
            type="button"
            onClick={item.onClick}
            className={`m-1 rounded px-4 text-wa-text ${
              activeTab === item.name
                ? "bg-wa-accent text-white shadow"
                : "bg-transparent hover:bg-wa-hover"
            }`}
          >
            {item.name}
          </button>
        ))}
    </div>
  );
});

TabsFilter.displayName = "TabsFilter";

TabsFilter.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      onClick: PropTypes.func,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ).isRequired,
  activeTab: PropTypes.string,
  variant: PropTypes.oneOf(["wa"]),
};

export default TabsFilter;
